import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save'
import DeleteIcon from '@mui/icons-material/Delete'
import { useParams } from 'react-router-dom'
import { useQuery, useMutation, useApolloClient } from '@apollo/client'
import {  getAllStyles, getPrompt, getAllTags } from '../graphql/queries'
import ProgressBar from '../components/circularProgress/circularProgress'
import {
  TextField,
  MenuItem,
  FormControl,
  Select,
  Alert,
  CircularProgress,
  Box,
  Typography,
  Button,
  InputLabel,
  Snackbar,
  Autocomplete,
  Chip,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { deletePrompt, updatePrompt } from '../graphql/mutation'
import { uploadToS3 } from '../utils/uploadToS3'
import ImageUploadField from '../components/imageUpload';
import VideoAutoConvert from '../components/VideoAutoConvert';
import ToolRatioManager from '../components/ToolRatioManager';
import { designType, inferanceModelEnum } from '../utils/enum'

const outPutFormat = [
  { value: 'webp', name: 'webp' },
  { value: 'jpg', name: 'jpg' },
  { value: 'png', name: 'png' },
]

const genderOptions = [
  { value: 'MALE', name: 'MALE' },
  { value: 'FEMALE', name: 'FEMALE' },
  { value: 'OTHER', name: 'OTHER' },
]

const aspectRatios = [
  { value: '1:1', name: '1:1' },
  { value: '16:9', name: '16:9' },
  { value: '21:9', name: '21:9' },
  { value: '3:2', name: '3:2' },
  { value: '2:3', name: '2:3' },
  { value: '4:5', name: '4:5' },
  { value: '5:4', name: '5:4' },
  { value: '3:4', name: '3:4' },
  { value: '4:3', name: '4:3' },
  { value: '9:16', name: '9:16' },
  { value: '9:21', name: '9:21' },
]


const toolType = [
  { value: 'IMG2VIDEO', name: 'IMG2VIDEO' },
  { value: 'IMG2VIDEO_WITH_TEXT', name: 'IMG2VIDEO_WITH_TEXT' },
  { value: 'PREDICT_WITH_MODEL', name: 'PREDICT_WITH_MODEL' },
  { value: 'TEXT2VIDEO', name: 'TEXT2VIDEO' },
  { value: 'TRAIN', name: 'TRAIN' },
  { value: 'VIDEO2VIDEO', name: 'VIDEO2VIDEO' },
  {value: 'IMG2IMG', name: 'IMG2IMG'},
]
if (typeof window !== 'undefined') {
  window.addEventListener('error', e => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
      e.stopImmediatePropagation()
    }
  })
}

export default function PromptPage() {
  const { id } = useParams()
  const client = useApolloClient()
  const navigate = useNavigate()

  // Helper function to check if current tool type needs prediction parameters
  const needsPredictionParams = (toolType) => {
    return toolType === 'PREDICT_WITH_MODEL'
  }

  // Helper function to check if current tool type needs inference model
  const needsInferenceModel = (toolType) => {
    return toolType === 'PREDICT_WITH_MODEL' || toolType === 'IMG2IMG'
  }

  const [prompt, setPrompt] = useState({
  prompt: '',
  banner: '',
  secondBanner: '',
  videoUrl: '',
  gifUrl: '',
  webmUrl: '',
  webpUrl: '',
  designType: 'SMALL',
  toolType: 'PREDICT_WITH_MODEL',
  isVisible: '',
  isPublic: false,
  rowNumber: 1,
  createdAt: '',
  updatedAt: '',
  styleId: '',
  tagIds: [],
  gender: '',
  aspectRatio: '',
  guidanceScale: '',
  loraScale: '',
  numInferenceSteps: '',
  outputFormat: '',
  outputQuality: '',
  numOfOutPuts: '',
  promptSvg: '',
  beforeImage: '',
  highlighted: false,
  intputImageCount: 0,
  templateId: '',
  inferanceModelEnum: '',
  cost: 10,
  name: '',
  detailImage: '',
})


  const [promptData, setPromptData] = useState(null)
  const [thumbnail, setThumbnail] = useState(null)
  const [selectedTags, setSelectedTags] = useState([])
  const [selectedThumbnail,setSelectedThumbnail]=useState(null)
  const [beforeImageFile, setBeforeImageFile] = useState(null)
  const [selectedBeforeImageUrl, setSelectedBeforeImageUrl] = useState(null)
  const [promptSvgFile, setPromptSvgFile] = useState(null)
  const [selectedPromptSvgUrl, setSelectedPromptSvgUrl] = useState(null)
  const [videoFile, setVideoFile] = useState(null)
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null)
  const [gifFile, setGifFile] = useState(null)
  const [selectedGifUrl, setSelectedGifUrl] = useState(null)
  const [webmFile, setWebmFile] = useState(null)
  const [selectedWebmUrl, setSelectedWebmUrl] = useState(null)
  const [webpFile, setWebpFile] = useState(null)
  const [selectedWebpUrl, setSelectedWebpUrl] = useState(null)
  const [secondBannerFile, setSecondBannerFile] = useState(null)
  const [selectedSecondBannerUrl, setSelectedSecondBannerUrl] = useState(null)
  const [detailImageFile, setDetailImageFile] = useState(null)
  const [selectedDetailImageUrl, setSelectedDetailImageUrl] = useState(null)
  const [progress, setProgress] = useState(false)

  const [snackBarOpen,setSnackBarOpen] = useState(false)
  const [snackBarMessage,setSnackBarMessge] = useState(null)
  const [snackBarSeverity, setSnackBarSeverity] = useState('success')

  const { loading, refetch } = useQuery(getPrompt, {
    variables: { promptId: id },
    onCompleted: data => {
      setPromptData(data.getPrompt)
    },
  })
  const { data: styleData } = useQuery(getAllStyles)
  const selectStyleData =
  styleData && styleData.getAllStylesAdmin ? styleData.getAllStylesAdmin.styles : []

  const { data: tagsData } = useQuery(getAllTags)
  const tags = tagsData?.getAllTags || []

  // Optimized callback handlers - must be at component top level
  const handleRatiosChange = useCallback(async () => {
    // Refetch the prompt data to get updated ratios without causing full re-render
    try {
      const { data: refetchedData } = await refetch();
      if (refetchedData && refetchedData.getPrompt) {
        // Only update the toolRatios part to avoid full re-render
        setPromptData(prevData => ({
          ...prevData,
          toolRatios: refetchedData.getPrompt.toolRatios
        }));
      }
    } catch (error) {
      console.error('Error refetching prompt data:', error);
    }
  }, [refetch]);

  const handleImageDelete = useCallback((imageType) => {
    switch (imageType) {
      case 'beforeImage':
        setSelectedBeforeImageUrl(null);
        setBeforeImageFile(null);
        setPrompt(prev => ({ ...prev, beforeImage: '' }));
        break;
      case 'promptSvg':
        setSelectedPromptSvgUrl(null);
        setPromptSvgFile(null);
        setPrompt(prev => ({ ...prev, promptSvg: '' }));
        break;
      case 'gif':
        setSelectedGifUrl(null);
        setGifFile(null);
        setPrompt(prev => ({ ...prev, gifUrl: '' }));
        break;
      case 'thumbnail':
        setSelectedThumbnail(null);
        setThumbnail(null);
        setPrompt(prev => ({ ...prev, banner: '' }));
        break;
      case 'video':
        setSelectedVideoUrl(null);
        setVideoFile(null);
        setPrompt(prev => ({ ...prev, videoUrl: '' }));
        break;
      case 'webm':
        setSelectedWebmUrl(null);
        setWebmFile(null);
        setPrompt(prev => ({ ...prev, webmUrl: '' }));
        break;
      case 'webp':
        setSelectedWebpUrl(null);
        setWebpFile(null);
        setPrompt(prev => ({ ...prev, webpUrl: '' }));
        break;
      case 'secondBanner':
        setSelectedSecondBannerUrl(null);
        setSecondBannerFile(null);
        setPrompt(prev => ({ ...prev, secondBanner: '' }));
        break;
      case 'detailImage':
        setSelectedDetailImageUrl(null);
        setDetailImageFile(null);
        setPrompt(prev => ({ ...prev, detailImage: '' }));
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (promptData) {
      // Only update if this is the initial load
      const isInitialLoad = !prompt.prompt;
      
      if (isInitialLoad) {
        setPrompt(prevPrompt => ({
          ...prevPrompt,
          prompt: promptData.prompt,
          banner: promptData.banner,
          secondBanner: promptData.secondBanner,
          videoUrl: promptData.videoUrl,
          gifUrl: promptData.gifUrl,
          webmUrl: promptData.webmUrl,
          webpUrl: promptData.webpUrl,
          designType: promptData.designType || 'SMALL',
          toolType: promptData.toolType || 'PREDICT_WITH_MODEL',
          isVisible: promptData.isVisible,
          isPublic: promptData.isPublic || false,
          rowNumber: promptData.rowNumber || 1,
          createdAt: promptData.createdAt,
          updatedAt: promptData.updatedAt,
          gender: promptData.gender,
          aspectRatio: promptData.aspectRatio,
          styleId: promptData.Style?.id || '',
          guidanceScale: promptData.guidanceScale,
          loraScale: promptData.loraScale,
          numInferenceSteps: promptData.numInferenceSteps,
          outputFormat: promptData.outputFormat,
          outputQuality: promptData.outputQuality,
          numOfOutPuts: promptData.numOfOutPuts,
          promptSvg: promptData.promptSvg,
          beforeImage: promptData.beforeImage,
          tagIds: promptData.tags?.map(tag => tag.id) || [],
          highlighted: promptData.highlighted || false,
          intputImageCount: promptData.intputImageCount || 0,
          templateId: promptData.templateId || '',
          inferanceModelEnum: promptData.inferanceModelEnum || '',
          cost: promptData.cost || 10,
          name: promptData.name || '',
          detailImage: promptData.detailImage || '',
        }));
        
        // Only update image URLs on initial load
        if (isInitialLoad) {
          setSelectedThumbnail(promptData.banner);
          setSelectedSecondBannerUrl(promptData.secondBanner);
          setSelectedVideoUrl(promptData.videoUrl);
          setSelectedGifUrl(promptData.gifUrl);
          setSelectedWebmUrl(promptData.webmUrl);
          setSelectedWebpUrl(promptData.webpUrl);
          setSelectedDetailImageUrl(promptData.detailImage);
          setSelectedBeforeImageUrl(promptData.beforeImage);
          setSelectedPromptSvgUrl(promptData.promptSvg);
          
          // Set selected tags
          if (promptData.tags) {
            setSelectedTags(promptData.tags);
          }
        }
      }
    }
  // prompt.prompt is intentionally excluded: including it would re-run this
  // effect on every keystroke and reset all fields back to server values.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promptData])
  const [updatePromptMutation] = useMutation(updatePrompt)
  const [deletePromptMutation] = useMutation(deletePrompt)
  const [openImageModal, setOpenImageModal] = useState(false)

  const [modalImageSrc, setModalImageSrc] = useState('')

  const handleImageClick = src => {
    setModalImageSrc(src)
    setOpenImageModal(true)
  }
  if (loading) {
    return <ProgressBar />
  }

  const handleChange = e => {
    const { name, value } = e.target
    setPrompt(prev => ({ ...prev, [name]: value }))
  }
  const handleThumbnailSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedThumbnail(URL.createObjectURL(selectedFile))
    setThumbnail(selectedFile)
  }
  const handleBeforeImageSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedBeforeImageUrl(URL.createObjectURL(selectedFile))
    setBeforeImageFile(selectedFile)
  }
  const handlePromptSvgSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedPromptSvgUrl(URL.createObjectURL(selectedFile))
    setPromptSvgFile(selectedFile)
  }

  const handleVideoSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedVideoUrl(URL.createObjectURL(selectedFile))
    setVideoFile(selectedFile)
  }

  const handleGifSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedGifUrl(URL.createObjectURL(selectedFile))
    setGifFile(selectedFile)
  }

  const handleWebmSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedWebmUrl(URL.createObjectURL(selectedFile))
    setWebmFile(selectedFile)
  }

  const handleWebpSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedWebpUrl(URL.createObjectURL(selectedFile))
    setWebpFile(selectedFile)
  }

  const handleSecondBannerSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedSecondBannerUrl(URL.createObjectURL(selectedFile))
    setSecondBannerFile(selectedFile)
  }

  const handleDetailImageSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedDetailImageUrl(URL.createObjectURL(selectedFile))
    setDetailImageFile(selectedFile)
  }

  const handleSnackBarClose=()=>{
  setSnackBarOpen(false)
}

  const handleUpdatePrompt = async () => {
    setProgress(true)
    try{
    const thumbnailUrl = thumbnail ? await uploadToS3(thumbnail, 'img', client) : prompt.banner
    const secondBannerUrl = secondBannerFile ? await uploadToS3(secondBannerFile, 'img', client) : prompt.secondBanner
    const beforeImageUrl = beforeImageFile
      ? await uploadToS3(beforeImageFile, 'img', client)
      : prompt.beforeImage
    const promptSvgUrl = promptSvgFile
      ? await uploadToS3(promptSvgFile, 'img', client)
      : prompt.promptSvg

    const videoUrl = videoFile ? await uploadToS3(videoFile, 'video', client) : prompt.videoUrl
    const gifUrl = gifFile ? await uploadToS3(gifFile, 'gif', client) : prompt.gifUrl
    const webmUrl = webmFile ? await uploadToS3(webmFile, 'video', client) : prompt.webmUrl
    const webpUrl = webpFile ? await uploadToS3(webpFile, 'img', client) : prompt.webpUrl
    const detailImageUrl = detailImageFile ? await uploadToS3(detailImageFile, 'img', client) : prompt.detailImage

    const gpqResponse = await updatePromptMutation({
      variables: {
        promptId: id,
        prompt: prompt.prompt,
        banner: thumbnailUrl,
        secondBanner: secondBannerUrl,
        videoUrl: videoUrl,
        gifUrl: gifUrl,
        webmUrl: webmUrl,
        webpUrl: webpUrl,
        designType: prompt.designType,
        toolType: prompt.toolType,
        isVisible: prompt.isVisible,
        isPublic: prompt.isPublic,
        rowNumber: Number(prompt.rowNumber),
        styleId: prompt.styleId,
        gender: prompt.gender,
        aspectRatio: prompt.aspectRatio,
        guidanceScale: Number(prompt.guidanceScale),
        loraScale: Number(prompt.loraScale),
        numInferenceSteps: Number(prompt.numInferenceSteps),
        outputFormat: prompt.outputFormat,
        outputQuality: Number(prompt.outputQuality),
        numOfOutPuts: Number(prompt.numOfOutPuts),
        promptSvg: promptSvgUrl,
        beforeImage: beforeImageUrl,
        tagIds: prompt.tagIds,
        highlighted: prompt.highlighted,
        intputImageCount: Number(prompt.intputImageCount),
        templateId: prompt.templateId,
        inferanceModelEnum: prompt.inferanceModelEnum || null,
        cost: Number(prompt.cost) || 10,
        name: prompt.name,
        detailImage: detailImageUrl,
        },
      // Refetch queries to update the table data
      refetchQueries: [
        'GetAllPromptsAdmin', // This will refresh the prompts table
        'GetPrompt' // This will refresh the current prompt data
      ],
      awaitRefetchQueries: true // Wait for refetch to complete
    })
    if (gpqResponse.data) {
      setSnackBarMessge('Prompt updated successfully')
      setSnackBarOpen(true)
      setSnackBarSeverity('success')
        setTimeout(() => {
        // Navigate back to prompts with scroll restoration
        navigate('/prompts', { 
          state: { 
            scrollToPosition: true,
            preserveScroll: true 
          }
        });
      }, 1000);
    } else {
      setSnackBarMessge('Update failed')
      setSnackBarOpen(true)
      setSnackBarSeverity('error')
    }
  } catch (error) {
      console.error('Error updating prompt:', error);
      setSnackBarMessge(`Update failed: ${error.message}`);
      setSnackBarSeverity('error');
      setSnackBarOpen(true);
  }finally {
      setProgress(false);
    }
  }
  const handleDeletePrompt = async () => {
  try {
    const gpqResponse = await deletePromptMutation({
      variables: {
        promptId: id,
      },
      // Refetch queries to update the table data
      refetchQueries: [
        'GetAllPromptsAdmin', // This will refresh the prompts table
      ],
      awaitRefetchQueries: true // Wait for refetch to complete
    });

    if (gpqResponse.data) {
      setSnackBarMessge('Prompt deleted successfully');
      setSnackBarSeverity('success');
      setSnackBarOpen(true);
      setTimeout(() => {
        // Navigate back to prompts with scroll restoration
        navigate('/prompts', { 
          state: { 
            scrollToPosition: true,
            preserveScroll: true 
          }
        });
      }, 1000);
    } else {
      throw new Error('No data returned from delete prompt');
    }
  } catch (error) {
    console.error("Delete error:", error);
    setSnackBarMessge(`Delete failed: ${error.message}`);
    setSnackBarSeverity('error');
    setSnackBarOpen(true);
  }
};


  return (
    <Box sx={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={3000}
        onClose={handleSnackBarClose}
        message={snackBarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert 
            onClose={handleSnackBarClose} 
            severity={snackBarSeverity} 
            sx={{ width: '100%' }}
          >
            {snackBarMessage}
          </Alert>
      </Snackbar>

      {/* Sticky Header with Actions */}
      <Box 
        sx={{ 
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: 'white',
          borderBottom: '1px solid #e9ecef',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 4, flexWrap: 'wrap', gap: 2 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <ChatBubbleOutlineIcon fontSize="large" sx={{ color: '#212552' }} />
            <Typography variant="h4" fontWeight="bold" color="#212552">
              Prompt Details
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button
              onClick={handleDeletePrompt}
              variant="outlined"
              color="error"
              startIcon={<DeleteIcon />}
              sx={{ 
                borderRadius: 2,
                px: 3,
                '&:hover': { 
                  backgroundColor: '#e74c3c', 
                  color: 'white',
                  borderColor: '#e74c3c'
                }
              }}
            >
              Delete Prompt
            </Button>
            <Button
              onClick={handleUpdatePrompt}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              sx={{ 
                borderRadius: 2,
                px: 4,
                backgroundColor: '#3498db',
                '&:hover': { backgroundColor: '#2980b9' }
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Box>
      {progress && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255,255,255,0.7)',
            zIndex: 1300,
          }}
        >
          <CircularProgress size={80} thickness={5} />
        </Box>
      )}

      {/* Main Content Container */}
      <Box sx={{ maxWidth: '1400px', mx: 'auto', p: 4, display: 'flex', flexDirection: 'column', gap: 4 }}>
        
        {/* Basic Information Card */}
        <Paper sx={{ p: 4, borderRadius: 3, boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
          <Typography variant='h5' sx={{ mb: 4, fontWeight: 'bold', color: '#2c3e50' }}>
            Basic Information
          </Typography>
          
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <TextField
                fullWidth
                label="ID"
                value={promptData?.id || ''}
                InputProps={{ readOnly: true }}
                variant="outlined"
                sx={{ 
                  '& .MuiOutlinedInput-root': { borderRadius: 2 },
                  '& .MuiInputBase-input': { backgroundColor: '#f8f9fa' }
                }}
              />
              <TextField
                fullWidth
                label="Created At"
                value={promptData?.createdAt || ''}
                InputProps={{ readOnly: true }}
                variant="outlined"
                sx={{ 
                  '& .MuiOutlinedInput-root': { borderRadius: 2 },
                  '& .MuiInputBase-input': { backgroundColor: '#f8f9fa' }
                }}
              />

              <TextField
                fullWidth
                name="name"
                variant="outlined"
                label="Name"
                value={prompt.name ?? ''}
                onChange={handleChange}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />

              {/* Tool Type Selection - Moved to top for better visibility */}
              <FormControl fullWidth>
                <InputLabel>Tool Type</InputLabel>
                <Select
                  label="Tool Type"
                  name="toolType"
                  value={String(prompt.toolType || '')}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                >
                  {toolType.map(({ value, name }, idx) => (
                    <MenuItem key={idx} value={String(value)}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            
            <Box>
              <TextField
                fullWidth
                name="prompt"
                variant="outlined"
                label="Prompt"
                multiline
                rows={6}
                value={prompt.prompt ?? ''}
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '16px',
                    lineHeight: '1.5',
                    borderRadius: 2
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: '16px',
                  }
                }}
              />
            </Box>
          </Box>
        </Paper>
        
        {/* Settings & Configuration Card */}
        <Paper sx={{ borderRadius: 3, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
          <Box sx={{ p: 4, pb: 2 }}>
            <Typography variant='h5' sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
              Settings & Configuration
            </Typography>
          </Box>

          {/* Numeric Parameters Accordion */}
          <Accordion defaultExpanded sx={{ boxShadow: 'none', '&:before': { display: 'none' } }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ 
                px: 4, 
                backgroundColor: '#f8f9fa',
                '&:hover': { backgroundColor: '#e9ecef' }
              }}
            >
              <Typography variant='h6' sx={{ fontWeight: 600, color: '#495057' }}>
                Numeric Parameters
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 4, pb: 3 }}>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                {[
                  { name: 'rowNumber', label: 'Row Number', type: 'number', onlyForPredict: true },
                  { name: 'guidanceScale', label: 'Guidance Scale', type: 'number', onlyForPredict: true },
                  { name: 'loraScale', label: 'Lora Scale', type: 'number', onlyForPredict: true },
                  { name: 'numInferenceSteps', label: 'Number Inference Steps', type: 'number', onlyForPredict: true },
                  { name: 'outputQuality', label: 'Output Quality', type: 'number', onlyForPredict: true },
                  { name: 'numOfOutPuts', label: 'Number Of Outputs', type: 'number', onlyForPredict: true },
                  { name: 'intputImageCount', label: 'Input Image Count', showAlways: true },
                  { name: 'cost', label: 'Cost (Credits)', type: 'number', showAlways: true },
                  { name: 'templateId', label: 'Template ID', type: 'text', showAlways: true },
                ].filter(({ onlyForPredict, showAlways }) => {
                  if (showAlways) return true; // Always show fields marked as showAlways
                  if (onlyForPredict) return needsPredictionParams(prompt.toolType); // Only show for PREDICT_WITH_MODEL
                  return true; // Show other fields by default
                }).map(({ name, label, type }) => (
                  <TextField
                    key={name}
                    fullWidth
                    name={name}
                    variant="outlined"
                    label={label}
                    type={type}
                    value={prompt[name] ?? ''}
                    onChange={handleChange}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* Type & Format Settings Accordion */}
          <Accordion defaultExpanded sx={{ boxShadow: 'none', '&:before': { display: 'none' } }}>
            <AccordionSummary 
              expandIcon={<ExpandMoreIcon />}
              sx={{ 
                px: 4, 
                backgroundColor: '#f8f9fa',
                '&:hover': { backgroundColor: '#e9ecef' }
              }}
            >
              <Typography variant='h6' sx={{ fontWeight: 600, color: '#495057' }}>
                Type & Format Settings
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 4, pb: 3 }}>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {/* Left column fields */}
                  {[
                    { label: 'Gender', key: 'gender', options: genderOptions, showAlways: true },
                    { label: 'Aspect Ratio', key: 'aspectRatio', options: aspectRatios, onlyForPredict: true },
                    { label: 'Output Format', key: 'outputFormat', options: outPutFormat, onlyForPredict: true },
                  ].filter(({ onlyForPredict, showAlways }) => {
                    if (showAlways) return true; // Always show fields marked as showAlways
                    if (onlyForPredict) return needsPredictionParams(prompt.toolType); // Only show for PREDICT_WITH_MODEL
                    return true; // Show other fields by default
                  }).map(({ label, key, options }) => (
                    <FormControl key={key} fullWidth>
                      <InputLabel>{label}</InputLabel>
                      <Select
                        label={label}
                        name={key}
                        value={String(prompt[key] || '')}
                        onChange={handleChange}
                        variant="outlined"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      >
                        {options.map(({ value, name }, idx) => (
                          <MenuItem key={idx} value={String(value)}>
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ))}
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {/* Right column fields */}
                  {[
                    { label: 'Design Type', key: 'designType', options: designType, showAlways: true },
                    { label: 'Inference Model', key: 'inferanceModelEnum', options: inferanceModelEnum, needsInference: true },
                  ].filter(({ onlyForPredict, showAlways, needsInference }) => {
                    if (showAlways) return true; // Always show fields marked as showAlways
                    if (onlyForPredict) return needsPredictionParams(prompt.toolType); // Only show for PREDICT_WITH_MODEL
                    if (needsInference) return needsInferenceModel(prompt.toolType); // Show for PREDICT_WITH_MODEL and IMG2IMG
                    return true; // Show other fields by default
                  }).map(({ label, key, options }) => (
                    <FormControl key={key} fullWidth>
                      <InputLabel>{label}</InputLabel>
                      <Select
                        label={label}
                        name={key}
                        value={String(prompt[key] || '')}
                        onChange={handleChange}
                        variant="outlined"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      >
                        {options.map(({ value, name }, idx) => (
                          <MenuItem key={idx} value={String(value)}>
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ))}

                  <FormControl fullWidth>
                    <InputLabel id="style-select-label">Style</InputLabel>
                    <Select
                      labelId="style-select-label"
                      name="styleId"
                      value={prompt.styleId}
                      onChange={handleChange}
                      label="Style"
                      variant="outlined"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    >
                      {selectStyleData.map((style) => (
                        <MenuItem key={style.id} value={style.id}>
                          {style.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* Tags & Visibility Settings Accordion */}
          <Accordion defaultExpanded sx={{ boxShadow: 'none', '&:before': { display: 'none' } }}>
            <AccordionSummary 
              expandIcon={<ExpandMoreIcon />}
              sx={{ 
                px: 4, 
                backgroundColor: '#f8f9fa',
                '&:hover': { backgroundColor: '#e9ecef' }
              }}
            >
              <Typography variant='h6' sx={{ fontWeight: 600, color: '#495057' }}>
                Tags & Visibility Settings
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 4, pb: 3 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {/* Tags Selection */}
                <Autocomplete
                  multiple
                  options={tags}
                  getOptionLabel={(option) => option.name}
                  value={selectedTags}
                  onChange={(event, newValue) => {
                    setSelectedTags(newValue)
                    setPrompt(prev => ({
                      ...prev,
                      tagIds: newValue.map(tag => tag.id)
                    }))
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Tags"
                      placeholder="Select tags..."
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.name}
                        size="small"
                        sx={{
                          backgroundColor: '#e3f2fd',
                          color: '#1565c0',
                          '&:hover': { backgroundColor: '#bbdefb' }
                        }}
                      />
                    ))
                  }
                />

                {/* Visibility toggles removed for all tool types */}
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* Tool Ratios Management */}
          <ToolRatioManager
            promptId={id}
            toolRatios={promptData?.toolRatios || []}
            onRatiosChange={handleRatiosChange}
          />
        </Paper>

        {/* Media Assets Card */}
        <Paper sx={{ p: 4, borderRadius: 3, boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
          <Typography variant='h5' sx={{ mb: 4, fontWeight: 'bold', color: '#2c3e50' }}>
            Media Assets
          </Typography>

          {/* ── Manuel görseller ── */}
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
            <ImageUploadField
              label="Before Image"
              description="Efekt uygulanmadan önceki örnek görsel · PNG / JPG / WebP"
              file={beforeImageFile}
              inputName="beforeimage"
              imageUrl={selectedBeforeImageUrl ?? prompt?.beforeImage}
              onImageClick={handleImageClick}
              onImageChange={handleBeforeImageSelected}
              onDelete={() => handleImageDelete('beforeImage')}
            />
            <ImageUploadField
              label="Thumbnail Photo"
              description="Liste / kart görünümünde gösterilen ana kapak görseli · PNG / JPG / WebP"
              file={thumbnail}
              imageUrl={selectedThumbnail ?? prompt?.banner}
              inputName="thumbnailPhoto"
              onImageClick={handleImageClick}
              onImageChange={handleThumbnailSelected}
              onDelete={() => handleImageDelete('thumbnail')}
            />
            <ImageUploadField
              label="Prompt SVG"
              description="Prompt'u temsil eden ikon ya da grafik · SVG / PNG"
              file={promptSvgFile}
              inputName="promptsvg"
              imageUrl={selectedPromptSvgUrl ?? prompt?.promptSvg}
              onImageClick={handleImageClick}
              onImageChange={handlePromptSvgSelected}
              onDelete={() => handleImageDelete('promptSvg')}
            />
            <ImageUploadField
              label="Second Banner"
              description="İkinci tanıtım / pazarlama görseli · PNG / JPG / WebP"
              file={secondBannerFile}
              inputName="secondBanner"
              imageUrl={selectedSecondBannerUrl ?? prompt?.secondBanner}
              onImageClick={handleImageClick}
              onImageChange={handleSecondBannerSelected}
              onDelete={() => handleImageDelete('secondBanner')}
            />
            <ImageUploadField
              label="Detail Image"
              description="Prompt detay sayfasında gösterilen büyük görsel · PNG / JPG / WebP"
              file={detailImageFile}
              inputName="detailImage"
              imageUrl={selectedDetailImageUrl ?? prompt?.detailImage}
              onImageClick={handleImageClick}
              onImageChange={handleDetailImageSelected}
              onDelete={() => handleImageDelete('detailImage')}
            />
          </Box>

          {/* ── Video alanları ── */}
          <Box sx={{ mt: 4, pt: 4, borderTop: '1px solid #e9ecef' }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 3, color: '#2c3e50' }}>
              Video Alanları
            </Typography>

            {/* Video + Auto Convert yan yana */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3, mb: 3 }}>
              <ImageUploadField
                label="Video"
                description="Ana önizleme videosu — buraya MP4 yükle, diğerleri Auto Convert ile üretilir"
                file={videoFile}
                imageUrl={selectedVideoUrl ?? prompt?.videoUrl}
                inputName="video"
                isVideo
                accept="video/mp4"
                onImageClick={handleImageClick}
                onImageChange={handleVideoSelected}
                onDelete={() => handleImageDelete('video')}
              />
              <VideoAutoConvert
                videoFile={videoFile}
                onConvertComplete={(results) => {
                  if (results.webm) {
                    setWebmFile(results.webm);
                    setSelectedWebmUrl(URL.createObjectURL(results.webm));
                  }
                  if (results.webp) {
                    setWebpFile(results.webp);
                    setSelectedWebpUrl(URL.createObjectURL(results.webp));
                  }
                  if (results.gif) {
                    setGifFile(results.gif);
                    setSelectedGifUrl(URL.createObjectURL(results.gif));
                  }
                }}
              />
            </Box>

            {/* Auto-convert çıktıları: 3 kolon */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 3 }}>
              <ImageUploadField
                label="WEBM Video"
                description="Orijinal çözünürlük & FPS · format değişikliği"
                file={webmFile}
                inputName="webm"
                imageUrl={selectedWebmUrl ?? prompt?.webmUrl}
                isVideo
                accept="video/webm"
                autoConvertable
                onImageClick={handleImageClick}
                onImageChange={handleWebmSelected}
                onDelete={() => handleImageDelete('webm')}
              />
              <ImageUploadField
                label="WEBP Image"
                description="Animasyonlu · 360p, source fps (max 30)"
                file={webpFile}
                inputName="webp"
                imageUrl={selectedWebpUrl ?? prompt?.webpUrl}
                accept="image/webp"
                autoConvertable
                onImageClick={handleImageClick}
                onImageChange={handleWebpSelected}
                onDelete={() => handleImageDelete('webp')}
              />
              <ImageUploadField
                label="GIF"
                description="Animasyonlu · 360p, source fps (max 30)"
                file={gifFile}
                inputName="gif"
                imageUrl={selectedGifUrl ?? prompt?.gifUrl}
                accept="image/gif"
                autoConvertable
                onImageClick={handleImageClick}
                onImageChange={handleGifSelected}
                onDelete={() => handleImageDelete('gif')}
              />
            </Box>
          </Box>
        </Paper>
      </Box>


    {openImageModal && (
      <Box
        onClick={() => setOpenImageModal(false)}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.7)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={modalImageSrc}
          alt="Full Preview"
          style={{
            maxWidth: '90%',
            maxHeight: '90%',
            objectFit: 'contain',
            borderRadius: '10px',
          }}
          onClick={e => e.stopPropagation()} 
        />
      </Box>
    )}
  </Box>

  )
}
